import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import HorizontalLayoutContainer from '../publicLayout/components/HorizontalLayoutContainer';
import { H5 } from 'foundations-components/transitional/components/H5';
import { H2 } from 'foundations-components/transitional/components/H2';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { NUMBER_OF_USERS_CERTIFIED } from 'academy-common-lib/constants/general';
import { getProxyUrl } from 'academy-common-lib/utils/url';
import usageTracker from '../../utils/usageTracker';
import StyledSection from '../publicLayout/components/StyledSection';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { ThemedPrimaryRouterButton } from '../../components/ThemedComponents';
import { getLocationDescriptor } from '../../utils/routing';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { CertificationIcon } from 'foundations-assets/icons/components/CertificationIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const VIEW_ALL_CERTIFICATIONS_URL = '/courses?awardType=ONLY_SHOW_CERTIFICATE_COURSES';
const CERTIFICATIONS_CONFIG = [{
  route: '/courses/inbound',
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.certificationsSection.inbound"
  }),
  description: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.certificationsSection.inboundDescription"
  }),
  iconColor: 'fill-brand-default'
}, {
  route: '/courses/social-media',
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.certificationsSection.socialMedia"
  }),
  description: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.certificationsSection.socialMediaDescription"
  }),
  iconColor: 'fill-accent-green-default'
}, {
  route: '/courses/email-marketing',
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.certificationsSection.emailMarketing"
  }),
  description: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.certificationsSection.emailMarketingDescription"
  }),
  iconColor: 'fill-accent-red-default'
}, {
  route: '/courses/content-marketing',
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.certificationsSection.contentMarketing"
  }),
  description: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.certificationsSection.contentMarketingDescription"
  }),
  iconColor: 'fill-accent-yellow-default'
}, {
  route: '/courses/inbound-sales',
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.certificationsSection.inboundSales"
  }),
  description: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.certificationsSection.inboundSalesDescription"
  }),
  iconColor: 'icon-core-subtle'
}];
const getGridTemplateColumns = (isMobile, isTablet) => {
  if (!isTablet) {
    return 'repeat(5, 1fr)';
  }
  return isMobile ? '1fr' : 'repeat(auto-fill, minmax(45%, 1fr))';
};
const CertificateLinkCard = ({
  iconColor,
  title,
  description,
  href,
  to
}) => {
  const handleCertificationClick = () => {
    usageTracker.track('interaction', {
      action: 'certification-link-click',
      href
    });
  };
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(RouterLink, {
      onClick: handleCertificationClick,
      to: getLocationDescriptor(to),
      children: /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx(IconHolder, {
            color: iconColor,
            icon: CertificationIcon,
            padding: "0",
            size: "900"
          }), /*#__PURE__*/_jsx(Text, {
            color: "text-interactive-default",
            textAlign: "center",
            typography: "heading-50",
            children: title
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Paragraph, {
      children: description
    })]
  });
};
const CertificationsSection = () => {
  const {
    isMobile,
    isTablet
  } = useMediaQuery();
  const handleViewAllClick = () => {
    usageTracker.track('interaction', {
      action: 'view-all-certifications-click'
    });
  };
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledSection, {
      "data-test-id": "certifications-section",
      children: /*#__PURE__*/_jsx(View, {
        textAlign: "center",
        children: /*#__PURE__*/_jsxs(HorizontalLayoutContainer, {
          children: [/*#__PURE__*/_jsx(H2, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.certificationsSection.title"
            })
          }), /*#__PURE__*/_jsx(H5, {
            marginBlockEnd: isMobile ? '1300' : '1000',
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.certificationsSection.description",
              options: {
                count: NUMBER_OF_USERS_CERTIFIED
              }
            })
          }), /*#__PURE__*/_jsx(CardGrid, {
            columnGap: "500",
            gridTemplateColumns: getGridTemplateColumns(isMobile, isTablet),
            marginBlock: "800",
            rowGap: "700",
            children: CERTIFICATIONS_CONFIG.map(certification => /*#__PURE__*/_jsx(CertificateLinkCard, {
              description: certification.description,
              href: getProxyUrl(certification.route),
              iconColor: certification.iconColor,
              title: certification.title,
              to: certification.route
            }, certification.route))
          }), /*#__PURE__*/_jsx(ThemedPrimaryRouterButton, {
            onClick: handleViewAllClick,
            to: VIEW_ALL_CERTIFICATIONS_URL,
            use: "primary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.certificationsSection.viewAll"
            })
          })]
        })
      })
    })
  );
};
export default CertificationsSection;